import { RunStates } from './runStates'

export const StateChanges = {
  SET_TEXT_FOR_API_CALL: 'SET_TEXT_FOR_API_CALL',
  SET_FILE_FORMAT: 'SET_FILE_FORMAT',
  SET_TEXT_STYLE: 'SET_TEXT_STYLE',
  SET_URL_LIST: 'SET_URL_LIST',
  UPDATE_URL_LIST: 'UPDATE_URL_LIST',
  SET_USER_EMAIL: 'SET_USER_EMAIL',
  SET_SERVER_ERROR: 'SET_SERVER_ERROR',
  SET_JOB_ID: 'SET_JOB_ID',
  SET_RESULTS: 'SET_RESULTS',
  RESET: 'RESET',
  SAVE_UPPY_STATE: 'SAVE_UPPY_STATE',
  SET_UPLOAD_STATUS: 'SET_UPLOAD_STATUS',

  MORPH_NOT_RUN: 'MORPH_NOT_RUN',
  MORPH_RUNNING: 'MORPH_RUNNING',
  MORPH_TIMED_OUT: 'MORPH_TIMED_OUT',
  MORPH_FAILED: 'MORPH_FAILED',
  MORPH_COMPLETE: 'MORPH_COMPLETE',
}

export const Actions = {
  RUN_TEXT_MORPH: 'RUN_TEXT_MORPH',
  RUN_MORPH: 'RUN_MORPH',
  CHECK_STATUS: 'CHECK_STATUS'
}

export const BlankState = {
  morphApiState: RunStates.NOT_RUN,
  fileFormat: 'BGU',
  textStyle: 'modern',
  textForApiCall: "",
  results: [],
  jobId: null,
  UDarr: [],
  urlList: [],
  userEmail: '',
  uppyState: {},
  uploadStatus: {}
}
